// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-mochi_spinner__s6u-B","placeHolderShimmer":"spinner-mochi_placeHolderShimmer__7Ynlh"};